import { render, staticRenderFns } from "./VaimoTopHeader.vue?vue&type=template&id=5b41e2b2&scoped=true&"
import script from "./VaimoTopHeader.vue?vue&type=script&lang=ts&"
export * from "./VaimoTopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoTopHeader.vue?vue&type=style&index=0&id=5b41e2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b41e2b2",
  null
  
)

export default component.exports